'use client';
import Gallery from '@/components/smile/gallery/Gallery';
import {useTranslations} from 'next-intl';
import Link from 'next/link';
import './page.scss';

export default function Page() {
  const t = useTranslations();
  return (
    <section className="gallery">
      <div className="title-group">
        <div className="flex w-full justify-between items-center">
          <Link prefetch={false} className="back-btn" href={'/smile-meter'}>
            <img alt="img" src={`/img/smile/gallery/icon-back.svg`} />
            <span>{t.raw('Smile.gallery.back')}</span>
          </Link>
          <div className="title flex justify-between items-center h-[48px]">
            <img alt="img" src={`/img/smile/gallery/icon-smile.svg`} />
            <div className="leading-[normal]">
              {t.raw('Smile.gallery.title')}
            </div>
          </div>
          <div className="w-[80px]"></div>
        </div>
        <div className="description">
          <span>{t.raw('Smile.gallery.description')}</span>
        </div>
      </div>
      <Gallery showFull={true} />
    </section>
  );
}
